import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GoogleTagManagerService } from '../../../../services/google-tag-manager.service';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  standalone: true
})
export class VideoComponent implements OnInit {
  url: SafeResourceUrl | null = null;

  constructor(
    private sanitizer: DomSanitizer,
    private gtmService: GoogleTagManagerService,
    @Inject(MAT_DIALOG_DATA) public data: { url: string; name: string }
  ) {}

  ngOnInit() {
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.url);
    this.gtmService.pushEvent({ event: 'video_views', type: { video_title: this.data.name } });
  }
}
